import React,{useState} from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import CategoryPage from '../pages/CategoriesPage/CategoryPage';
import LandingPage from '../pages/LandingPage/LandingPage';
import Navbar from '../components/layout-components/Navbar/Navbar'
import Footer from '../components/layout-components/Footer/Footer'
import Courses from '../components/CategoriesPage/courses/Courses'
import Modules from '../components/Modules/Modules';
import Themes from '../components/Modules/Themes';
import Table from '../components/Table/Table.jsx'
import Myprofile from '../components/myprofile/Myprofile';
import Lesson from '../components/lesson-component/Lesson';
import EnterenceTests from '../pages/TestsPages/EnterenceTests';
import Payment from '../components/payment-section/Payment'
import Chatsection from '../components/chatsection/Chatsection';
const LandingRoutes = () => {

    return (

        <>  
            <BrowserRouter>
                <Navbar />
                <Switch>
                    <Route path="/categories/courses/modules/themes/lesson" component={Lesson} />
                    <Route path="/categories/courses/modules/themes" component={Themes} />
                    <Route path="/categories/courses/modules/testenterence" component={EnterenceTests}/>
                    <Route path="/categories/courses/modules" component={Modules} />
                    <Route path="/categories/courses/payment" component={Payment} />
                    <Route path="/categories/courses" component={Courses} />
                    <Route path="/categories" component={CategoryPage} />
                    <Route path="/history" component={Table}/>
                    <Route path="/chat" component={Chatsection}/>
                    <Route path="/" component={LandingPage} />
                </Switch>
                <Footer />
            </BrowserRouter>
        </>
    );
}

export default LandingRoutes;
